import { translate } from '@openclassrooms/translations';
import { styled, SxProps, Theme } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';

interface Props {
  label?: string;
  sx?: SxProps<Theme>;
}

const StyledLabel = styled(Typography)(({ theme: { palette, spacing } }) => ({
  padding: spacing(0, 2),
  backgroundColor: palette.layout.background.navigation,
}));

const Root = styled('div')(({ theme: { palette, spacing } }) => ({
  width: '100%',
  height: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: spacing(3.5, 'auto'),
  backgroundColor: palette.layout.line.divider,
}));

const Divider = ({ label = translate('auth.divider.or'), sx }: Props) => (
  <Root>
    <StyledLabel variant="bodySmall" sx={sx}>
      {label}
    </StyledLabel>
  </Root>
);

export default Divider;
